import { render } from "./pointList.vue?vue&type=template&id=a5411236&scoped=true"
import script from "./pointList.vue?vue&type=script&lang=js"
export * from "./pointList.vue?vue&type=script&lang=js"

import "@/styles/common.css?vue&type=style&index=0&id=a5411236&scoped=true&lang=css"
import "@/styles/striNew.css?vue&type=style&index=1&id=a5411236&scoped=true&lang=css"
import "./pointList.vue?vue&type=style&index=2&id=a5411236&scoped=true&lang=css"

import exportComponent from "/Users/cole/Desktop/중요/tcd-partnerpage-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5411236"]])

export default __exports__